import { render, staticRenderFns } from "./Newsale.vue?vue&type=template&id=a53d4d24&scoped=true&"
import script from "./Newsale.vue?vue&type=script&lang=js&"
export * from "./Newsale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53d4d24",
  null
  
)

export default component.exports